var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2500,
    height: 1533,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 512 314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "68.2%",
    x2: "27.8%",
    y1: "17.5%",
    y2: "89.8%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32.9%",
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.5%",
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "93.2%",
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "43.3%",
    x2: "159.2%",
    y1: "55.2%",
    y2: "-18.3%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "13.8%",
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.3%",
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "71.4%",
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90.8%",
    stopColor: "#6CC04A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "-4413.8%",
    x2: "5327.9%",
    y1: "13.4%",
    y2: "13.4%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "9.2%",
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.6%",
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59.7%",
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2%",
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "-4.4%",
    x2: "101.5%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "9.2%",
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.6%",
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59.7%",
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2%",
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "-9713.8%",
    x2: "27.9%",
    y1: "36.2%",
    y2: "36.2%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "9.2%",
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.6%",
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59.7%",
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2%",
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "-103.9%",
    x2: "100.8%",
    y1: "50.3%",
    y2: "50.3%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "9.2%",
    stopColor: "#6CC04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "28.6%",
    stopColor: "#66B848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "59.7%",
    stopColor: "#54A044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "86.2%",
    stopColor: "#41873F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "130.6%",
    x2: "4.4%",
    y1: "-211.1%",
    y2: "201.6%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#41873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "32.9%",
    stopColor: "#418B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.5%",
    stopColor: "#419637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "93.2%",
    stopColor: "#3FA92D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3FAE2A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M57.9 1.9a6 6 0 0 0-5.9 0l-48.6 28c-1.9 1-3 3-3 5.1v56.3c0 2 1.2 4 3 5L52 124.6a6 6 0 0 0 5.9 0l48.7-28.1c1.8-1 2.9-3 2.9-5.1V35c0-2-1.2-4-3-5L58 1.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#539E43",
    d: "M253.1 313c-1.7 0-3.3-.4-4.8-1.2l-15.4-9.1c-2.3-1.3-1.2-1.7-.5-2a28 28 0 0 0 7-3c.3-.3.8-.2 1.1 0l11.8 7c.5.3 1 .3 1.4 0l46.1-26.6c.5-.3.7-.7.7-1.3v-53.3c0-.6-.2-1-.7-1.2l-46.1-26.6c-.5-.3-1-.3-1.4 0l-46.1 26.6c-.5.2-.7.8-.7 1.2v53.3c0 .5.2 1 .7 1.3l12.6 7.3c6.8 3.4 11-.6 11-4.7v-52.6c0-.6.7-1.3 1.5-1.3h5.9c.7 0 1.3.5 1.3 1.3v52.6c0 9.2-5 14.5-13.6 14.5-2.6 0-4.7 0-10.6-3l-12.2-6.8c-3-1.8-4.8-5-4.8-8.5v-53.3c0-3.4 1.8-6.7 4.8-8.4l46.2-26.7c2.8-1.6 6.8-1.6 9.7 0l46 26.7c3 1.7 5 5 5 8.4V277c0 3.5-2 6.7-5 8.5L258 312c-1.5.6-3.3 1-4.9 1zm14.2-36.5c-20.2 0-24.4-9.3-24.4-17.1 0-.7.6-1.4 1.4-1.4h6c.7 0 1.3.4 1.3 1.1 1 6.1 3.6 9.2 15.8 9.2 9.8 0 14-2.2 14-7.4 0-3-1.2-5.2-16.4-6.7-12.6-1.3-20.4-4-20.4-14.1 0-9.4 7.8-15 21-15 14.8 0 22 5.1 23 16.2 0 .4-.1.7-.4 1-.2.3-.5.5-.9.5h-6c-.6 0-1.1-.4-1.3-1-1.3-6.4-5-8.5-14.4-8.5-10.6 0-12 3.7-12 6.5 0 3.4 1.6 4.4 16 6.3 14.1 1.8 20.8 4.5 20.8 14.4 0 10.2-8.4 16-23 16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M110 104.7c0-2-1.1-4-3-5L58 71.3c-.8-.4-1.7-.7-2.6-.8h-.5c-1 0-1.9.4-2.7.8l-49 28.2c-1.8 1-3 3-3 5.1l.1 75.8c0 1 .6 2.1 1.5 2.6 1 .6 2.1.6 3 0l29-16.7c2-1 3-3 3-5v-35.5c0-2.1 1.2-4 3-5.1l12.4-7.2c1-.6 2-.8 3-.8s2.1.2 3 .8l12.3 7.2c1.9 1 3 3 3 5v35.5c0 2.1 1.2 4 3 5.1l29.1 16.7c1 .6 2.1.6 3 0 1-.5 1.5-1.5 1.5-2.6v-75.8zM345.6.3c-1-.4-2.1-.4-3 0a3 3 0 0 0-1.4 2.6V78c0 .7-.4 1.4-1 1.9-.8.3-1.4.3-2.1 0l-12.3-7a6 6 0 0 0-5.9 0L271 101c-1.8 1-3 3-3 5.1v56.5c0 2.1 1.2 4 3 5.1l49 28.3a6 6 0 0 0 6 0l49-28.3c1.8-1 3-3 3-5v-141a6 6 0 0 0-3-5.2L345.5.3zM341 144.1c0 .6-.3 1-.7 1.3l-16.8 9.7a1.7 1.7 0 0 1-1.5 0l-16.7-9.7c-.5-.2-.7-.8-.7-1.3v-19.4c0-.6.2-1 .7-1.3l16.7-9.7a1.7 1.7 0 0 1 1.5 0l16.8 9.7c.4.3.7.8.7 1.3v19.4zm167.5-19.9c1.9-1 3-3 3-5v-13.8c0-2-1.2-4-3-5L460 72a6 6 0 0 0-5.9 0l-49 28.3c-1.9 1-3 3-3 5.1V162c0 2.1 1.1 4 3 5.1l48.6 27.8c1.9 1 4.1 1 5.8 0l29.5-16.5c1-.4 1.5-1.5 1.5-2.5s-.6-2-1.5-2.5L439.8 145a3 3 0 0 1-1.5-2.5v-17.7c0-1 .5-2 1.5-2.5l15.3-8.8a2.8 2.8 0 0 1 3 0l15.4 8.8a3 3 0 0 1 1.5 2.5v13.9c0 1 .6 2 1.5 2.5 1 .6 2.1.6 3 0l29.1-17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#539E43",
    d: "M456.3 121.6a1 1 0 0 1 1.1 0l9.4 5.4c.4.2.6.6.6 1v11c0 .4-.2.7-.6 1l-9.4 5.4a1 1 0 0 1-1.1 0l-9.4-5.4c-.3-.3-.5-.6-.5-1v-11c0-.4.2-.8.5-1l9.4-5.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(134 70.5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9 1.9 3 29.9A6 6 0 0 0 0 35v56.3C0 92.7.6 94 1.5 95L56.3 1.2c-1.4-.3-3-.2-4.4.6zM56.6 125l1.4-.6 48.8-28.1c1.8-1 3-3 3-5.1V35c0-1.5-.7-3-1.7-4l-51.5 94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m106.7 30-49-28.1a8 8 0 0 0-1.4-.6L1.5 95a6 6 0 0 0 1.6 1.4l49 28c1.3.9 3 1.1 4.4.7L108 31a6 6 0 0 0-1.2-1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.8 91.3V35c0-2-1.3-4-3.1-5l-49-28.1a5.1 5.1 0 0 0-1.8-.7l53.5 91.4c.3-.4.4-.8.4-1.3zM3.1 30A6 6 0 0 0 0 35v56.3c0 2 1.4 4 3.1 5l49 28.2c1 .7 2.3.9 3.7.7L3.5 29.8 3 30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    d: "m50.4.8-.7.4h1l-.3-.4z",
    transform: "translate(0 -9.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    d: "M106.8 105.6a6.6 6.6 0 0 0 2.9-3.7L56 10.4a5.9 5.9 0 0 0-4.2.7L3.4 39l52.3 95.4a8 8 0 0 0 2.2-.7l48.9-28.2z",
    transform: "translate(0 -9.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    d: "m111.3 104.7-.3-.6v.8l.3-.2z",
    transform: "translate(0 -9.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    d: "M106.8 105.6 58 133.7a7 7 0 0 1-2.2.7l1 1.7 54-31.3v-.7l-1.4-2.3c-.2 1.6-1.2 3-2.6 3.8z",
    transform: "translate(0 -9.2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    d: "M106.8 105.6 58 133.7a7 7 0 0 1-2.2.7l1 1.7 54-31.3v-.7l-1.4-2.3c-.2 1.6-1.2 3-2.6 3.8z",
    transform: "translate(0 -9.2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.a0109903234521729c0d41401fcaae85.svg";
export { ForwardRef as ReactComponent };